import { ReactComponent as Empty } from "../../../../../common/assets/icons/empty.svg";
import Toggle from "../../../../components/common/toggle";
import { CustomerData } from "../../../../../common/hooks/console/management/customer/useGetCustomer";
import { usePutCustomerStatus } from "../../../../../common/hooks/console/management/customer/usePutCustomerStatus";
import { ReactComponent as Dropdown } from "../../../../assets/icons/dropdown.svg";

interface CustomerTableProps {
    data?: CustomerData[];
    onRowClick?: (code: number, customerIdx: number, customerSpecial: boolean) => void;
    code: number;
    selectedRow: number;
    onSort: (field: string) => void;
    statusFilter: boolean | null;
    onStatusFilterChange: (value: boolean | null) => void;
}

const CustomerTable = ({ data, onRowClick, code, selectedRow, onSort, statusFilter, onStatusFilterChange }: CustomerTableProps) => {
    const putCustomerStatusMutation = usePutCustomerStatus();
    const handleChangeStatus = (id: number) => {
        const payload = {
            id,
        };
        putCustomerStatusMutation.mutate(payload);
    };
    return (
        <table className="table-fixed w-full text-gray2">
            {/* Header */}
            <thead className=" text-sm border-y border-gray3 h-10">
                <tr>
                    <th className="px-2 min-w-20 w-20">
                        <div className="flex items-center px-1.5 justify-between">
                            <p>구분</p>
                            <Dropdown className="cursor-pointer" onClick={() => onSort("customer_category")} />
                        </div>
                    </th>
                    <th className="px-2 text-start w-[80px]">고객코드</th>
                    <th className="px-2 text-start border-r border-gray4">
                        <div className="flex items-center gap-4 justify-between">
                            <p>고객명</p>
                            <Dropdown className="cursor-pointer" onClick={() => onSort("customer_name")} />
                        </div>
                    </th>
                    <th className="px-2 text-start">담당자명</th>
                    <th className="px-2 text-start">담당자 연락처</th>
                    <th className="px-2 text-start">담당자 이메일</th>
                    <th className="px-2 text-start min-w-[120px] w-[120px]">등록일자</th>
                    <th className="px-2 text-start min-w-[100px] w-[100px]">
                        <div className="flex items-center gap-1">
                            <button
                                onClick={() => onStatusFilterChange(statusFilter === true ? null : true)}
                                className={`cursor-pointer underline ${statusFilter === true ? "text-primary2 font-bold" : "text-gray2"}`}
                            >
                                노출
                            </button>
                            <span>/</span>
                            <button
                                onClick={() => onStatusFilterChange(statusFilter === false ? null : false)}
                                className={`cursor-pointer underline ${statusFilter === false ? "text-primary2 font-bold" : "text-gray2"}`}
                            >
                                숨김
                            </button>
                        </div>
                    </th>
                </tr>
            </thead>
            {/* Body */}
            <tbody>
                {data?.length ? (
                    data?.map((customer: any) => (
                        <tr
                            key={customer.customer_idx}
                            className={`border-b border-gray4 text-sm min-h-[50px] cursor-pointer hover:bg-[#E6EEDD]  ${
                                selectedRow === customer.customer_idx && code !== 0 ? "bg-[#F9EBEB]" : ""
                            }`}
                            onClick={() => onRowClick?.(customer.customer_category, customer.customer_idx, customer.special)}
                        >
                            <td
                                className={`px-2 text-center font-bold ${customer.customer_category === 1 ? "text-primary2 bg-primary4" : "text-blue bg-gray6"}`}
                            >
                                {customer.customer_category === 1 ? "고객" : "타지점"}
                            </td>
                            <td className="px-3">{customer.customer_idx}</td>
                            <td className="px-2 border-r border-gray4 ">{customer.customer_name}</td>
                            <td className="px-2">{customer.customer_manager?.manager_name || ""}</td>
                            <td className="px-2 text-xs">{customer.customer_manager?.manager_mobile || ""}</td>
                            <td className="px-2 text-xs break-all">{customer.customer_manager?.manager_email || ""}</td>
                            <td className="px-2 text-xs text-gray3">{customer.reg_date}</td>
                            <td className="flex items-center justify-center h-[50px]">
                                <Toggle
                                    onToggle={e => {
                                        e.stopPropagation();
                                        handleChangeStatus(customer.customer_idx);
                                    }}
                                    className="pl-2"
                                    onLabel="노출"
                                    offLabel="숨김"
                                    isOn={customer.status}
                                />
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={7} className="text-center">
                            <div className="flex flex-col items-center gap-5 py-4 mt-52">
                                <Empty />
                                <p className="text-grayicon text-lg">등록된 내역이 없습니다.</p>
                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default CustomerTable;
